/* global BigInt */
export const toLatinDigits = (value) => String(value ?? "")
  .replace(/[۰-۹]/g, (digit) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(digit)))
  .replace(/[٠-٩]/g, (digit) => String("٠١٢٣٤٥٦٧٨٩".indexOf(digit)));

export const toPersianDigits = (value) => toLatinDigits(value)
  .replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[Number(digit)]);

export const formatNumber = (value, opts = {}) => {
  if (value == null || String(value).trim() === "") return "—";
  const text = toLatinDigits(value).replace(/[,٬]/g, "").replace(/٫/g, ".").trim();
  // Keep database integer and decimal strings exact; converting them to Number
  // first would discard significant digits before Intl applies its formatting.
  const number = /^-?\d+$/.test(text) ? BigInt(text) : text;
  if (typeof number !== "bigint" && !Number.isFinite(Number(number))) return "—";
  return new Intl.NumberFormat("fa-IR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...opts,
  }).format(number);
};
